import giveActionPoints from './giveActionPoints';
var PmdActions = {
  'facebook:socialshare:click': [giveActionPoints]
};
export default PmdActions;